import { DateFieldRhf } from '@xemplo/date-field';

import * as S from '../../modal.styles';

export function PayDate() {
  return (
    <S.FormLabel>
      Pay Date
      <DateFieldRhf
        name="adhocPayDate"
        aria-label="Pay Date"
        placeholder="Select date"
        rules={{ required: 'This field is required' }}
      />
    </S.FormLabel>
  );
}
